/* eslint-disable eqeqeq */
import React, { ButtonHTMLAttributes } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { Button } from './styles';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  $width?: string;
  $height?: string;
  $url?: string;
}

const BackButton: React.FC<Props> = ({ $url }) => {
  const navigate = useNavigate();

  return (
    <Button
      onClick={() =>
        $url && $url !== '' ? navigate($url ?? '') : navigate(-1)
      }
    >
      <FiArrowLeft />
      Back
    </Button>
  );
};

export default BackButton;
